import React from 'react'
import * as PhosphorIcons from '@phosphor-icons/react'

const EnvironmentalSdsSystemResult = ({result}) => {
  const fieldIcons = {
    dangerous_goods: { icon: 'Warning', color: 'text-red-700', bg: 'bg-red-200' },
    un_number: { icon: 'Number', color: 'text-blue-700', bg: 'bg-blue-200' },
    un_factor: { icon: 'Hash', color: 'text-purple-700', bg: 'bg-purple-200' },
    flash_point: { icon: 'Fire', color: 'text-orange-700', bg: 'bg-orange-200' },
    packaging_group: { icon: 'Package', color: 'text-green-700', bg: 'bg-green-200' },
    article_name: { icon: 'Tag', color: 'text-cyan-700', bg: 'bg-cyan-200' }
  };

  const formatField = (key, field) => {
    const icon = fieldIcons[key];
    const isPresent = field?.present;
    const hasValue = field?.value !== null && field?.value !== undefined;

    return (
      <div className={`mb-4 p-4 rounded-lg ${isPresent ? 'bg-base-100 shadow-md' : 'bg-base-200'}`}>
        <div className="flex items-center gap-3 mb-2">
          <div className={`p-2 rounded-lg ${icon?.bg || 'bg-base-200'}`}>
            {PhosphorIcons[icon?.icon] && 
              React.createElement(PhosphorIcons[icon?.icon], {
                size: 20,
                weight: "bold",
                className: icon?.color || 'text-base-content'
              })
            }
          </div>
          <h4 className="font-semibold text-lg capitalize text-base-content">{key.replace(/_/g, ' ')}</h4>
          <div className="ml-auto flex items-center gap-2">
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
              isPresent ? 'bg-success/30 text-success-700' : 'bg-warning/30 text-warning-700'
            }`}>
              {isPresent ? 'Present' : 'Not Present'}
            </span>
            <span className="px-2 py-1 rounded-full text-xs font-medium bg-info/30 text-info-700">
              {field?.confidence * 100}% confidence
            </span>
          </div>
        </div>

        {isPresent && (
          <div className="space-y-2 mt-3">
            {hasValue && (
              <div className="flex items-center gap-2">
                <span className="text-base-content/80 font-medium">Value:</span>
                <span className="font-semibold text-base-content">
                  {typeof field.value === 'boolean' 
                    ? (field.value ? 'Yes' : 'No')
                    : field.value}
                </span>
              </div>
            )}
            {field?.raw && (
              <div className="flex items-center gap-2">
                <span className="text-base-content/80 font-medium">Raw text:</span>
                <span className="font-mono text-sm font-medium text-base-content">{field.raw}</span>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="mt-4">
      <div className="card bg-base-100 shadow-md">
        <div className="card-body p-4">
          <div className="flex items-center gap-2 mb-4">
            <div className="p-2 rounded-lg bg-blue-200">
              <PhosphorIcons.FileText size={20} weight="bold" className="text-blue-700" />
            </div>
            <h3 className="card-title text-lg font-semibold text-base-content">Environmental SDS System</h3>
          </div>
          <div className="space-y-2">
            {result?.analysis && Object.entries(result.analysis).map(([key, value]) => (
              <div key={key}>
                {formatField(key, value)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnvironmentalSdsSystemResult;
